document.getElementById('quote').addEventListener('click', async (evt) => {
  evt.preventDefault();
  let quoteLoader = document.getElementById('quote-loader');
  let quoteSentSuccess = document.getElementById('quote-sent-success');
  let quoteSentError = document.getElementById('quote-sent-error');
  let quoteButton = document.getElementById('quote');
  quoteLoader.hidden = false;
  quoteSentSuccess.hidden = true;
  quoteSentError.hidden = true;
  let customerId = quoteButton.dataset.customerId;
  let customerEmail = quoteButton.dataset.customerEmail;
  try {
    let cart = await fetch("/cart.json").then(response => {
      if (response.status === 200) {
        return response.json();
      }
      quoteLoader.hidden = true;
      quoteSentError.hidden = false;
      let error = `Failed to get cart info, Shopify returned ${result.status} ${result.statusText}`;
      console.error(error);
      throw new Error(error);
    });

    if (customerId) {
      let payload = {
        "customer": {
          "id": customerId,
          "email": customerEmail
        },
        "cart": cart
      };

      let postOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      }

      fetch("/apps/rcapp/draftOrderCreate", postOptions)
        .then(response => {
          quoteLoader.hidden = true;
          if (response.status !== 200) {
            quoteSentError.hidden = false;
            console.error(response.errors);
          } else {
            quoteSentSuccess.hidden = false;
          }
        })
        .catch(error => {
          quoteLoader.hidden = true;
          quoteSentError.hidden = false;
          console.error(error);
        });
    } else {
      window.location.href = "/account/login?return_url=/cart";
    }
  } catch (error) {
    quoteLoader.hidden = true;
    quoteSentError.hidden = false;
    console.error(error);
  }


});
